export default "---\ntitle: Refund a Shipping Label\n---\n\n## Coming Soon\n"